
/**
 * SEO 配置 - models (Français)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - Générateur vidéo IA phare | WeryAI',
        description: 'Google Veo 3.1 : Modèle vidéo IA phare avec audio natif.',
        keywords: 'Google Veo 3.1, vidéo IA phare, générateur vidéo IA, WeryAI',
    },
    veo_3: {
        title: 'veo 3 Génération Vidéo et Image IA | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast Génération Vidéo et Image IA | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'sora 2 Génération Vidéo et Image IA | WeryAI',
        description: 'Experience sora 2 on WeryAI. High-quality results.',
        keywords: 'sora_2, AI, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 Génération Vidéo IA | WeryAI',
        description: 'WeryAI Video 1.0 pour créer des vidéos IA cinématographiques.',
        keywords: 'WeryAI Video 1.0, vidéo IA, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - Générateur d\'Images IA Natif | WeryAI',
        description: 'Utilisez WeryAI Image 2 pour une génération native d\'images IA époustouflantes ! Modèle phare avec contrôle de style avancé. Crédits gratuits, sans carte.',
        keywords: 'WeryAI Image 2, générateur d\'images IA natif, image IA phare, qualité studio IA, WeryAI Image gratuit, comment utiliser WeryAI Image 2, WeryAI',
    },
    image_grok_2: {
        title: 'Gratuit Grok 2 - Générateur d\'Images xAI | WeryAI',
        description: 'Utilisez Grok 2 sur WeryAI pour générer des images IA créatives ! Modèle xAI avec flexibilité artistique et styles visuels uniques. Crédits gratuits, sans carte.',
        keywords: 'Grok 2, Grok AI, générateur d\'images xAI, art IA, images IA créatives, Grok 2 gratuit, comment utiliser Grok 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 Générateur d\'Images | WeryAI',
        description: 'Nano Banana 2 propulsé par Gemini avec connaissance mondiale et recherche en temps réel. Générez des images factuellement précises et magnifiques à ultra-haute vitesse.',
        keywords: 'Nano Banana 2, Google AI, Gemini, génération d\'images, rendu texte, cohérence multi-sujets, 4K, WeryAI',
        og_title: `Générateur d'images Nano Banana 2 | WeryAI`,
        og_description: `Nano Banana 2, propulsé par Gemini, combine compréhension du monde et recherche en temps réel pour générer des images précises et esthétiques.`,
        twitter_title: `Générateur d'images Nano Banana 2 | WeryAI`,
        twitter_description: `Nano Banana 2, propulsé par Gemini, combine compréhension du monde et recherche en temps réel pour générer des images précises et esthétiques.`,
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: `Générateur d'images IA Nano Banana 2`,
        twitterImageAlt: `Générateur d'images IA Nano Banana 2`,
    },
    kling_ai: {
        title: 'kling ai Génération Vidéo et Image IA | WeryAI',
        description: 'Experience kling ai on WeryAI. High-quality results.',
        keywords: 'kling_ai, AI, WeryAI',
    },
    runway_ai: {
        title: 'runway ai Génération Vidéo et Image IA | WeryAI',
        description: 'Experience runway ai on WeryAI. High-quality results.',
        keywords: 'runway_ai, AI, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 Génération Vidéo et Image IA | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'hailuo ai Génération Vidéo et Image IA | WeryAI',
        description: 'Experience hailuo ai on WeryAI. High-quality results.',
        keywords: 'hailuo_ai, AI, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 Génération Vidéo et Image IA | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'seedance Génération Vidéo et Image IA | WeryAI',
        description: 'Experience seedance on WeryAI. High-quality results.',
        keywords: 'seedance, AI, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - Générateur Vidéo AI de Réalisateur | WeryAI',

        description: 'Créez des vidéos AI de niveau réalisateur avec Werydance 2.0 : références multimodales, cohérence narrative et simulation physique. Gratuit sur WeryAI.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, générateur vidéo AI, vidéo niveau réalisateur, vidéo multimodale, simulation physique, synchronisation labiale, texte en vidéo, vidéo AI gratuit, WeryAI',

        og_title: 'Werydance 2.0 - Générateur Vidéo AI de Réalisateur | WeryAI',

        og_description: 'Créez des vidéos AI de niveau réalisateur avec Werydance 2.0 : références multimodales, cohérence narrative et simulation physique. Gratuit sur WeryAI.',

        twitter_title: 'Werydance 2.0 - Générateur Vidéo AI de Réalisateur | WeryAI',

        twitter_description: 'Créez des vidéos AI de niveau réalisateur avec Werydance 2.0 : références multimodales, cohérence narrative et simulation physique. Gratuit sur WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    wan_2_6: {
        title: `Wan 2.6 | Générateur de vidéo IA avancé d'Alibaba | WeryAI`,
        description: `Wan 2.6 est le dernier modèle multimodal phare d'Alibaba pour la génération de vidéos IA, avec une qualité cinématographique en 1080p, une synchronisation audio-vidéo native et des capacités narratives multi-plans intelligentes. Essayez-le gratuitement sur WeryAI.`,
        keywords: 'Wan 2.6, Alibaba Wan 2.6, générateur de vidéo IA, modèle vidéo multimodal, texte vers vidéo, image vers vidéo, synchronisation audio, WeryAI Wan 2.6',
    },
    image_gpt_4o: {
        title: 'Gratuit GPT-4o - Générateur d\'Images OpenAI | WeryAI',
        description: 'Utilisez GPT-4o sur WeryAI pour créer des images par conversation ! IA OpenAI avec rendu de texte précis et résultats haute fidélité. Crédits gratuits, sans carte.',
        keywords: 'GPT-4o, GPT-4o image, générateur d\'images OpenAI, art IA conversationnel, GPT-4o gratuit, comment utiliser GPT-4o images, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Gratuit Nano Banana Pro - Générateur d\'Images IA | WeryAI',
        description: 'Utilisez Nano Banana Pro sur WeryAI pour les images IA haute fidélité ! Rivalise avec Midjourney en qualité. Crédits gratuits, sans carte.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google image IA, image IA par raisonnement, 4K image IA, Nano Banana Pro gratuit, comment utiliser Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: 'Gratuit Nano Banana - Générateur d\'Images IA | WeryAI',
        description: 'Utilisez Nano Banana sur WeryAI pour créer des images IA facilement ! Modèle IA polyvalent et rapide pour vos besoins créatifs. Crédits gratuits, sans carte.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google image IA, générateur IA rapide, cohérence de personnages, Nano Banana gratuit, comment utiliser Nano Banana, WeryAI',
    },
    image_flux: {
        title: 'Gratuit FLUX - Essayez le Générateur d\'Images IA | WeryAI',
        description: 'Utilisez FLUX sur WeryAI pour générer de superbes images IA ! Créé par l\'équipe Stable Diffusion avec une qualité visuelle exceptionnelle. Crédits gratuits, sans carte.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, générateur d\'images IA, texte vers image, art IA, FLUX gratuit, comment utiliser FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: 'Gratuit FLUX Kontext - Éditeur d\'Images IA Pro | WeryAI',
        description: 'Utilisez FLUX Kontext sur WeryAI pour une édition d\'images IA professionnelle ! Adhérence supérieure, typographie avancée et édition multi-étapes. Crédits gratuits, sans carte.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, éditeur d\'images IA, images IA pro, typographie IA, FLUX Kontext gratuit, comment utiliser FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: 'Gratuit Imagen 4 - Générateur d\'Images IA Google | WeryAI',
        description: 'Utilisez Google Imagen 4 sur WeryAI pour créer des images IA photoréalistes ! Contrôle de style polyvalent et génération de texte précise. Crédits gratuits, sans carte.',
        keywords: 'Imagen 4, Google Imagen, générateur d\'images IA Google, texte vers image, IA photoréaliste, Imagen gratuit, comment utiliser Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: 'Gratuit Qwen Image - Modèle d\'Images IA Alibaba | WeryAI',
        description: 'Utilisez Qwen Image sur WeryAI pour générer de l\'art IA multilingue ! Modèle open-source Alibaba avec rendu de texte supérieur. Crédits gratuits, sans carte.',
        keywords: 'Qwen Image, Alibaba AI, image IA open-source, rendu de texte multilingue, Qwen Image gratuit, comment utiliser Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: 'Gratuit Wan AI - Générateur d\'Images Alibaba | WeryAI',
        description: 'Utilisez Wan AI sur WeryAI pour des images IA haute fidélité ! Modèle Alibaba avec suivi précis des prompts et rendu photoréaliste. Crédits gratuits, sans carte.',
        keywords: 'Wan AI, Wan 2.5, générateur d\'images IA Alibaba, texte vers image, IA photoréaliste, Wan AI gratuit, comment utiliser Wan AI, WeryAI',
    },
    image_seendream: {
        title: 'Gratuit Seedream 4.0 - ByteDance Image IA | WeryAI',
        description: 'Utilisez Seedream 4.0 sur WeryAI pour une génération ultra-rapide d\'images IA ! Modèle ByteDance avec styles artistiques diversifiés. Crédits gratuits, sans carte.',
        keywords: 'Seedream, Seedream 4.0, ByteDance image IA, image IA ultra-rapide, styles artistiques IA, Seedream gratuit, comment utiliser Seedream, WeryAI',
    },
    image_dreamina: {
        title: 'Gratuit Dreamina 4.0 - IA d\'Image Multimodale | WeryAI',
        description: 'Utilisez Dreamina 4.0 sur WeryAI pour la création d\'images IA multimodale ! Croquis vers image, transfert de style et fusion de personnages. Crédits gratuits, sans carte.',
        keywords: 'Dreamina 4.0, ByteDance image IA, image IA multimodale, croquis vers image, transfert de style, Dreamina gratuit, comment utiliser Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Gratuit Seedream 4.5 - ByteDance Image IA | WeryAI',
        description: 'Utilisez Seedream 4.5 sur WeryAI pour la génération d\'images IA phare ! Dernier de ByteDance avec typographie précise et fusion multi-images. Crédits gratuits, sans carte.',
        keywords: 'Seedream 4.5, ByteDance image IA, modèle phare, rendu typographique, fusion multi-images, Seedream 4.5 gratuit, comment utiliser Seedream 4.5, WeryAI',
    },
    image_seedream_5_0: {
        title: "Seedream 5.0 Modèle Ultime de Génération d'Images | WeryAI",
        description: "Seedream 5.0 est le chef-d'œuvre de ByteDance en IA visuelle avec qualité native 8K, compréhension sémantique ultime, composition multi-sujets et rendu de texte 2.0. Essayez-le gratuitement sur WeryAI.",
        keywords: "Seedream 5.0, génération d'images IA, qualité 8K, compréhension sémantique, composition multi-sujets, rendu de texte, ByteDance, WeryAI",
        og_title: `Générateur d'Images Seedream 5.0 | WeryAI`,
        og_description: `Seedream 5.0 est le modèle phare de ByteDance pour la génération visuelle IA, avec qualité native 8K, compréhension sémantique avancée, composition multi-sujets et rendu de texte précis.`,
        twitter_title: `Générateur d'Images Seedream 5.0 | WeryAI`,
        twitter_description: `Seedream 5.0 est le modèle phare de ByteDance pour la génération visuelle IA, avec qualité native 8K, compréhension sémantique avancée, composition multi-sujets et rendu de texte précis.`,
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: `Générateur d'images IA Seedream 5.0`,
        twitterImageAlt: `Générateur d'images IA Seedream 5.0`,
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - Générateur Professionnel de Graphiques Vectoriels IA | WeryAI',
        description: 'Recraft V4 Vector est un générateur professionnel de graphiques vectoriels IA par Recraft.ai qui génère des vecteurs SVG éditables avec mise à l\'échelle sans perte, typographie précise et contrôle du style de marque. Essayez-le gratuitement sur WeryAI maintenant.',
        keywords: 'Recraft V4 Vector, génération de vecteurs IA, générateur SVG, vecteur véritable, conception de logo, icônes UI, illustration vectorielle, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'Gratuit Midjourney - Générateur d\'Art IA | WeryAI',
        description: 'Utilisez Midjourney sur WeryAI pour créer des images IA artistiques ! Célèbre pour son esthétique et sa qualité d\'éclairage. Crédits gratuits, sans carte.',
        keywords: 'Midjourney, Midjourney AI, générateur d\'art IA, images IA artistiques, Midjourney gratuit, alternative Midjourney, comment utiliser Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Générateur Vidéo IA | WeryAI',
        description: `Créez des vidéos impressionnantes avec Runway Gen-4.5 sur WeryAI. Architecture hybride autorégressive-diffusion pour une simulation physique précise et une cohérence temporelle.`,
        keywords: 'Runway Gen-4.5, générateur vidéo IA, vidéo IA cinématographique, simulation physique, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Générateur Vidéo IA | WeryAI',
        description: `Générez des vidéos haute qualité avec Kling 2.6 Pro sur WeryAI. Génération audiovisuelle native, qualité cinématographique 1080p, excellente adhérence aux prompts.`,
        keywords: 'Kling 2.6 Pro, générateur vidéo IA, vidéo IA haute qualité, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Générateur Vidéo Contrôle caméra | WeryAI',
        description: `Générez des vidéos IA cinématographiques avec Dreamina 3.0 (Jimeng 3.0) sur WeryAI. Contrôle précis des frames début/fin, mouvements de caméra professionnels et génération vidéo 1080p haute dynamique.`,
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, générateur vidéo IA, contrôle caméra, frames début fin, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Générateur Vidéo IA Génération Vidéo | WeryAI',
        description: `Libérez votre créativité sur WeryAI avec le générateur vidéo IA Kling O1. Parfait pour générer du contenu vidéo imaginatif et unique.`,
        keywords: 'Kling O1, générateur vidéo IA, vidéo IA créative, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - Générateur Vidéo AI Intelligent | WeryAI',

        description: 'Créez des vidéos AI avec Kling 3.0 : storyboard intelligent, synchronisation labiale multilingue et rendu de texte précis. Essai gratuit sur WeryAI.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, générateur vidéo AI, storyboard intelligent, synchronisation labiale, rendu de texte, texte en vidéo, image en vidéo, vidéo AI gratuit, WeryAI',

        og_title: 'Kling 3.0 - Générateur Vidéo AI Intelligent | WeryAI',

        og_description: 'Créez des vidéos AI avec Kling 3.0 : storyboard intelligent, synchronisation labiale multilingue et rendu de texte précis. Essai gratuit sur WeryAI.',

        twitter_title: 'Kling 3.0 - Générateur Vidéo AI Intelligent | WeryAI',

        twitter_description: 'Créez des vidéos AI avec Kling 3.0 : storyboard intelligent, synchronisation labiale multilingue et rendu de texte précis. Essai gratuit sur WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - Générateur Audio-Vidéo AI Natif 16s | WeryAI',

        description: 'Générez de l\'audio-vidéo natif de 16 secondes avec Vidu Q3 : montage intelligent, rendu de texte précis et lip-sync. Gratuit sur WeryAI.',

        keywords: 'Vidu Q3, Vidu AI, générateur vidéo AI, audio-vidéo natif 16s, storyboard intelligent, rendu de texte, synchronisation labiale, texte en vidéo, image en vidéo, vidéo AI gratuit, WeryAI',

        og_title: 'Vidu Q3 - Générateur Audio-Vidéo AI Natif 16s | WeryAI',

        og_description: 'Générez de l\'audio-vidéo natif de 16 secondes avec Vidu Q3 : montage intelligent, rendu de texte précis et lip-sync. Gratuit sur WeryAI.',

        twitter_title: 'Vidu Q3 - Générateur Audio-Vidéo AI Natif 16s | WeryAI',

        twitter_description: 'Générez de l\'audio-vidéo natif de 16 secondes avec Vidu Q3 : montage intelligent, rendu de texte précis et lip-sync. Gratuit sur WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_image_1_5: {
        title: 'Gratuit GPT Image 1.5 - Générateur d\'Art OpenAI | WeryAI',
        description: 'Utilisez GPT Image 1.5 sur WeryAI pour l\'art IA nouvelle génération ! Dernier modèle OpenAI avec créativité et détails améliorés. Crédits gratuits, sans carte.',
        keywords: 'GPT Image 1.5, modèle d\'image OpenAI, générateur d\'art IA, IA nouvelle génération, GPT Image 1.5 gratuit, comment utiliser GPT Image 1.5, WeryAI',
    },
}
